export const ServiceHistory = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  NONE: 'NONE',
};

export const ServiceHistoryName = {
  FULL: 'Full service history',
  PARTIAL: 'Partial service history',
  NONE: 'No service history',
};

export const ServiceType = {
  OIL_CHANGE: 'OIL_CHANGE',
  BRAKE_SERVICE: 'BRAKE_SERVICE',
  FULL_SERVICE: 'FULL_SERVICE',
  INSPECTION: 'INSPECTION',
  REPAIR: 'REPAIR',
  MAINTENANCE: 'MAINTENANCE',
  OTHER: 'OTHER',
};

export const ServiceTypeName = {
  OIL_CHANGE: 'Oil Change',
  BRAKE_SERVICE: 'Brake Service',
  FULL_SERVICE: 'Full Service',
  INSPECTION: 'Inspection',
  REPAIR: 'Repair',
  MAINTENANCE: 'Maintenance',
  OTHER: 'Other',
};
